export default (tracking_code = null) => ({
    tracking_data: null,
    async loadTrackingData() {
        this.tracking_data = await window.axios
            .post(
                "https://api.ship24.com/public/v1/trackers/track",
                { trackingNumber: tracking_code },
                {
                    headers: {
                        Authorization: "Bearer " + import.meta.env.VITE_SHIP24_TOKEN,
                    },
                },
            )
            .then(({ data }) => data.data);
    },
    get tracker() {
        if (!this.tracking_data || !this.tracking_data.trackings) return null;
        return this.tracking_data.trackings[0];
    },
    get events() {
        return this.tracker?.events ?? [];
    },
    get lastEvent() {
        return this.events[0];
    },
    formatDate(date) {
        return new Intl.DateTimeFormat(navigator.language, {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            hour12: false,
        }).format(Date.parse(date));
    },
    get isDelivered() {
        return this.tracker?.shipment?.statusMilestonee === "delivered";
    },
});
